<script lang="ts">
  import { page, router } from "@inertiajs/svelte"
  import { onMount } from "svelte"

  let lastRefreshTime = $state<number>(Date.now())
  const REFRESH_THRESHOLD_MS = 60 * 1000 // 1 minute

  function refreshIfNeeded() {
    const timeSinceLastRefresh = Date.now() - lastRefreshTime

    if (timeSinceLastRefresh >= REFRESH_THRESHOLD_MS) {
      router.reload()
      lastRefreshTime = Date.now()
    }
  }

  function handleVisibilityChange() {
    if (document.visibilityState === "visible") {
      refreshIfNeeded()
    }
  }

  function handlePageShow() {
    refreshIfNeeded()
  }

  $effect(() => {
    void $page.url
    lastRefreshTime = Date.now()
  })

  onMount(() => {
    lastRefreshTime = Date.now()
    document.addEventListener("visibilitychange", handleVisibilityChange)
    window.addEventListener("pageshow", handlePageShow)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      window.removeEventListener("pageshow", handlePageShow)
    }
  })
</script>
